import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { Markdown } from '@glowforge/ui-common/components';
import FAQTopicTOC from './faq-topic-toc';
import './faq-overview-page.less';

/**
 * FAQ Overview Page Contains a Header, some intro text, and the table of
 * contents for each faq topic.
 */
const FAQOverviewPage = ({ title, introText, faqSectionList }) => (
  <div className='FAQOverviewPage'>
    <Helmet title={title} />
    <h1 className='title'>{title}</h1>
    <Markdown className='intro' source={introText} />
    <ul>
      {faqSectionList.map((section) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <FAQTopicTOC key={section.slug} {...section} />
      ))}
    </ul>
  </div>
);

FAQOverviewPage.propTypes = {
  title: PropTypes.string,
  introText: PropTypes.string,
  faqSectionList: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    questions: PropTypes.array,
  })),
};

FAQOverviewPage.defaultProps = {
  title: 'FAQ',
  introText: '',
  faqSectionList: [],
};

export default FAQOverviewPage;
